import { combineEpics } from 'redux-observable';
import * as Rx from 'rxjs';
import { catchError } from 'rxjs/operators';

import * as moleculeObjectEpics from './molecule-object/molecule-object.epics';
import * as moleculeUtilEpics from './molecule-util/molecule-util.epics';

function catchable(epicMap: any) {
  return Object.values(epicMap).map((epic: any) => {
    return (...args: any[]) =>
      epic(...args).pipe(
        catchError(error => {
          return Rx.EMPTY;
        })
      );
  });
}

export default combineEpics(...catchable(moleculeObjectEpics), ...catchable(moleculeUtilEpics));
